const initialState = {
  sidebar: false,
  colorChart: false,
  alert: { show: false },
};

const togglesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "TOGGLE_SIDEBAR":
      return {
        ...state,
        sidebar: !state.sidebar,
      };
    case "TOGGLE_COLOR_CHART":
      return {
        ...state,
        colorChart: action.payload,
      };
    case "TOGGLE_ALERT":
      return {
        ...state,
        alert: action.payload,
      };
    default:
      return state;
  }
};

export default togglesReducer;
